export var Y_FIELD = '$$yField$$';
export var DIFF_FIELD = '$$diffField$$';
export var ABSOLUTE_FIELD = '$$absoluteField$$';
export var IS_TOTAL = '$$isTotal$$';
//# sourceMappingURL=constants.js.map